export enum UserRoleName {
  CommunityMember = 'COMMUNITY_MEMBER',
  CommunityAdmin = 'COMMUNITY_ADMIN',
}

enum UserRoleId {
  COMMUNITY_MEMBER = 1,
  COMMUNITY_ADMIN = 2,
}

export interface UserRole {
  id: UserRoleId;
  name: UserRoleName;
  label?: string;
}
